export default __webpack_public_path__ + "static/media/15-unpacking.e51ea4ac.png";